import { createCompNode, envRefs } from '@wix/thunderbolt-catharsis'
import type { StylableEditor } from '@wix/stylable-panel-drivers'
import type { Component, Style } from '@wix/thunderbolt-becky-types'
import type { FeatureRefs } from '../cssFeatures.types'
import { mapValuesValues } from '../../utils/mapValuesValues'
import { mapValues } from '../../utils/mapValues'
import type { BeckyModel } from '@wix/thunderbolt-becky-root'
import { getStylableCompCss, getStylableCompCssWithOverrides } from '@wix/thunderbolt-becky-root'
import { getSTCSS } from '../../utils/selectorsUtils'

const getStylableCSS = (
	style: Style,
	styleId: string | undefined,
	isMobileView: boolean,
	experiments: BeckyModel['experiments'],
	stylableInstance: StylableEditor,
	isEditor: boolean
) => {
	if (!style?.style?.properties || !styleId) {
		return undefined
	}

	const stylableStCss = getSTCSS(style)
	if (stylableStCss) {
		if (stylableInstance) {
			if (isEditor) {
				return getStylableCompCssWithOverrides(stylableInstance, styleId, style, isMobileView, experiments)
			}
			return getStylableCompCss(stylableInstance, styleId, style, isMobileView)
		}
	}

	return undefined
}

export const stylableCss = (isEditor: boolean) =>
	createCompNode({
		getDependencies: (component: Component, refs: FeatureRefs<'stylableCss'>) => {
			return {
				compStyles: component.styleId ? refs.compStyles(component) : null,
				isMobileView: envRefs.isMobileView,
				experiments: envRefs.experiments,
				stylableInstance: envRefs.stylableInstance,
			}
		},
		toViewItem: (component, deps) => {
			const { compStyles, isMobileView, experiments, stylableInstance } = deps

			if (!compStyles) {
				return null
			}

			if (compStyles.type === 'classic') {
				return {
					type: 'classic' as const,
					css: mapValues(compStyles.css, (style) =>
						getStylableCSS(
							style as Style,
							component.styleId,
							isMobileView,
							experiments,
							stylableInstance as StylableEditor,
							isEditor
						)
					),
				}
			}

			return {
				type: 'variants' as const,
				css: mapValuesValues(compStyles.css, (style) =>
					getStylableCSS(
						style as Style,
						component.styleId,
						isMobileView,
						experiments,
						stylableInstance as StylableEditor,
						isEditor
					)
				),
			}
		},
	})
